import type { ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Delete a booking service by ID.
 *
 * @endpoint DELETE /api/saas/me/bookings/{bookingId}/booking_services/{serviceId}
 * @scope saas
 */
export async function deleteBookingService(
  bookingId: ParameterID,
  serviceId: ParameterID
): Promise<void> {
  await api.delete(
    `/api/saas/me/bookings/${bookingId}/booking_services/${serviceId}`
  )
}
